import { TooltipTrigger } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';

import { ChatInputConfig } from '../../chat-input';
import * as Shared from '../../chat-input/chat-input-composer/ChatInputComposer.styles';

export interface ChatSubmitButtonProps {
  isMessagePending: boolean;
  inputValue: string;
  abortRequest?: () => void;
  config?: ChatInputConfig;
}

export const ChatSubmitButton = ({
  isMessagePending,
  inputValue,
  abortRequest,
  config,
}: ChatSubmitButtonProps) => {
  const { t } = useTranslation('chat');
  const isAlfredEverywhere = config?.alfredEverywhere;

  const hasEmptyInput = !inputValue.trim();
  const isSubmitButtonDisabled =
    hasEmptyInput || (isAlfredEverywhere && isMessagePending);

  return (
    <TooltipContainer
      label={t('chat:stopResponse')}
      inPortal
      trigger={[TooltipTrigger.Hover]}
      disabled={!isMessagePending}
    >
      {isMessagePending && !isAlfredEverywhere ? (
        <Shared.StyledSubmitButton
          data-testid="abort-button"
          iconName="Stop"
          onClick={abortRequest}
        />
      ) : (
        <Shared.StyledSubmitButton
          data-testid="submit-button"
          variant="primary"
          iconName="ArrowUp"
          disabled={isSubmitButtonDisabled}
        />
      )}
    </TooltipContainer>
  );
};
